/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FarmDto } from '../../models/farm-dto';

export interface FarmControllerFindAll$Params {
}

export function farmControllerFindAll(http: HttpClient, rootUrl: string, params?: FarmControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FarmDto>>> {
  const rb = new RequestBuilder(rootUrl, farmControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FarmDto>>;
    })
  );
}

farmControllerFindAll.PATH = '/api/farm/all';
